<template>
  <div class="selectli">
    <el-select v-model="selectoptionValue" size="small" class="w150" placeholder="请选择数据中心" @change="selectTenantId"
      style="width: 1.5rem;">
      <el-option v-for="item in selectoption" :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>

<script>
  export default {
    inject: ['reload'],
    name: "selectoption",
    data() {
      return {
        selectoption: [],
        selectoptionValue: '',
      }
    },
    created() {
      this.selectoption = JSON.parse(localStorage.getItem('selectoption'))
      this.selectoptionValue = localStorage.getItem('tenantId')
    },
    methods: {
      selectTenantId(e) {
        localStorage.setItem('tenantId', e)
        this.$store.state.tenantId = e
        this.reload()
      },
    }
  }
</script>

<style scoped>
  .selectli{display: inline-block;}
</style>



// WEBPACK FOOTER //
// src/components/selectoption/index.vue